/* Theme-only navigation: collections and products remain unchanged. */
(() => {
const init = () => {
const node=document.getElementById('GearonimoPreparedNavigation');if(!node)return;
let preparedNavigation;try{preparedNavigation=JSON.parse(node.textContent);}catch(error){return;}
preparedNavigation.forEach(d=>d.groups=(d.groups||[]).filter(g=>(g.items||[]).length));
  const isReadyPreparedUrl = (url) => {
    if (!url) return false;
    
    if (url.startsWith('/collections/') || url.startsWith('/pages/') || url.startsWith('/products/') || url.startsWith('/blogs/')) return true;
    return url.startsWith('/collections/all?');
  };

  const preparedButton = (label, className, suggestedUrl) => {
    if (isReadyPreparedUrl(suggestedUrl)) {
      const link = document.createElement('a');
      link.href = suggestedUrl;
      link.className = className;
      link.textContent = label;
      return link;
    }

    const button = document.createElement('span');
    button.className = className;
    button.dataset.inertLink = 'true';
    if (suggestedUrl) button.dataset.preparedUrl = suggestedUrl;
    button.textContent = label;
    return button;
  };

  const closePreparedDropdown = (item) => {
    if (!item) return;
    window.clearTimeout(item._preparedCloseTimer); item._preparedCloseTimer=null;
    item.classList.remove('is-open');
    item.querySelector('.primary-nav__link')?.setAttribute('aria-expanded', 'false');
  };

  const closePreparedDropdowns = (currentItem) => {
    document.querySelectorAll('.primary-nav__item.is-open').forEach((item) => {
      if (item === currentItem) return;
      closePreparedDropdown(item);
    });
  };

  const openPreparedDropdown = (item) => {
    if (!item) return;
    window.clearTimeout(item._preparedCloseTimer); item._preparedCloseTimer=null;
    closePreparedDropdowns(item);
    item.classList.add('is-open');
    const panel=item.querySelector('.primary-nav__dropdown');const link=item.querySelector('.primary-nav__link');
    if(panel&&link){
      let bridge=item.querySelector('.mapping-hover-bridge');if(!bridge){bridge=document.createElement('span');bridge.className='mapping-hover-bridge';bridge.setAttribute('aria-hidden','true');item.append(bridge);}
      bridge.style.position='absolute';
      const p=panel.getBoundingClientRect(),l=link.getBoundingClientRect(),parent=(bridge.offsetParent||document.documentElement).getBoundingClientRect();
      bridge.style.cssText='position:absolute;left:'+(p.left-parent.left)+'px;top:'+(l.bottom-parent.top-2)+'px;width:'+p.width+'px;height:'+Math.max(0,p.top-l.bottom+4)+'px;';
    }
    item.querySelector('.primary-nav__link')?.setAttribute('aria-expanded', 'true');
  };

  const isPointerInsideElement = (element, event) => {
    if (!element || typeof event?.clientX !== 'number' || typeof event?.clientY !== 'number') return false;
    const rect = element.getBoundingClientRect();
    return (
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
    );
  };

  let latestPreparedPointer=null;
  const isPointerInsidePreparedItem = (item,event) => {
    const dropdown=item?.querySelector('.primary-nav__dropdown');
    if(isPointerInsideElement(item,event)||isPointerInsideElement(dropdown,event))return true;
    if(!item||!dropdown||!event||!item.classList.contains('is-open'))return false;
    const link=item.querySelector('.primary-nav__link').getBoundingClientRect();
    const panel=dropdown.getBoundingClientRect();
    // Keep the open menu alive across the visual space below its department.
    return panel.height>0&&event.clientY>=link.bottom&&event.clientY<=panel.top&&event.clientX>=Math.min(link.left,panel.left)&&event.clientX<=Math.max(link.right,panel.right);
  };
  const schedulePreparedDropdownClose = (item,event) => {
    if(!item)return;
    if(event)latestPreparedPointer=event;
    if(item._preparedCloseTimer)return;
    item._preparedCloseTimer=window.setTimeout(()=>{
      item._preparedCloseTimer=null;
      if(item.matches(':focus-within')||isPointerInsidePreparedItem(item,latestPreparedPointer))return;
      closePreparedDropdown(item);
    },300);
  };
  const closePreparedDropdownsOutsidePointer = (event) => {
    if(event.pointerType&&event.pointerType!=='mouse'&&event.pointerType!=='pen')return;
    latestPreparedPointer=event;
    const hovered=event.target.closest?.('.primary-nav__item.has-dropdown');if(hovered&&!hovered.classList.contains('is-open'))openPreparedDropdown(hovered);
    document.querySelectorAll('.primary-nav__item.is-open').forEach(item=>{
      if(item.matches(':focus-within')||isPointerInsidePreparedItem(item,event)){
        window.clearTimeout(item._preparedCloseTimer);item._preparedCloseTimer=null;
      }else schedulePreparedDropdownClose(item);
    });
  };

  const renderDesktopNavigation = (container) => {
    container.innerHTML = '';
    preparedNavigation.forEach((item, index) => {
      const hasDropdown = Array.isArray(item.groups) && item.groups.length > 0;
      const navItem = document.createElement('div');
      navItem.className = `primary-nav__item${index === 0 ? ' primary-nav__item--featured' : ''}${hasDropdown ? ' has-dropdown' : ''}`;

      const topButton = preparedButton(item.label, 'primary-nav__link', item.suggestedUrl);
      if (hasDropdown) {
        topButton.classList.add('primary-nav__link--toggle');
        topButton.setAttribute('aria-haspopup', 'true');
        topButton.setAttribute('aria-expanded', 'false');
        topButton.addEventListener('focus', () => {
          if (navItem._preparedSuppressFocusOpen) {
            navItem._preparedSuppressFocusOpen = false;
            return;
          }
          openPreparedDropdown(navItem);
        });
        topButton.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          closePreparedDropdown(navItem);
          topButton.blur();
        });
        if (topButton.tagName === 'BUTTON') {
          topButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            openPreparedDropdown(navItem);
          });
        }
      }
      navItem.append(topButton);

      if (hasDropdown) {
        const dropdown = document.createElement('div');
        dropdown.className = `primary-nav__dropdown${item.groups.length > 3 ? ' primary-nav__dropdown--wide' : ''}`;

        const allLink = preparedButton(`All ${item.label}`, 'primary-nav__dropdown-link mapping-all-link', item.suggestedUrl); dropdown.append(allLink);
        item.groups.forEach((group) => {
          const groupColumn = document.createElement('section');
          groupColumn.className = 'primary-nav__group';

          groupColumn.append(preparedButton(group.label, 'primary-nav__dropdown-heading', group.suggestedUrl));

          if (Array.isArray(group.items) && group.items.length) {
            const list = document.createElement('div');
            list.className = 'primary-nav__dropdown-list';
            group.items.forEach((child) => {
              list.append(preparedButton(child.label, 'primary-nav__dropdown-link', child.suggestedUrl));
            });
            groupColumn.append(list);
          }

          dropdown.append(groupColumn);
        });

        navItem.append(dropdown);

        dropdown.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          navItem._preparedSuppressFocusOpen = true;
          closePreparedDropdown(navItem);
          topButton.focus();
        });

        navItem.addEventListener('mouseenter',()=>openPreparedDropdown(navItem));
        navItem.addEventListener('mouseleave',event=>schedulePreparedDropdownClose(navItem,event));
        navItem.addEventListener('pointerenter', (event) => {
          if (event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
          openPreparedDropdown(navItem);
        });

        navItem.addEventListener('pointerleave', (event) => {
          if (event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
          schedulePreparedDropdownClose(navItem, event);
        });

        navItem.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (navItem.matches(':focus-within') || navItem.matches(':hover')) return;
            closePreparedDropdown(navItem);
          }, 0);
        });
      }

      container.append(navItem);
    });
  };

  const renderMobileNavigation = (container) => {
    container.innerHTML = '';
    preparedNavigation.forEach((item) => {
      const hasDropdown = Array.isArray(item.groups) && item.groups.length > 0;
      if (!hasDropdown) {
        container.append(preparedButton(item.label, 'mobile-menu__link mobile-menu__link--single', item.suggestedUrl));
        return;
      }

      const details = document.createElement('details');
      details.className = 'mobile-menu__group';
      const summary = document.createElement('summary');
      summary.textContent = item.label;
      details.append(summary);

      const body = document.createElement('div');
      body.className = 'mobile-menu__group-body';
      body.append(preparedButton(`All ${item.label}`, 'mobile-menu__heading', item.suggestedUrl));
      item.groups.forEach((group) => {
        const subgroup = document.createElement('div');
        subgroup.className = 'mobile-menu__subgroup';
        subgroup.append(preparedButton(group.label, 'mobile-menu__heading', group.suggestedUrl));

        if (Array.isArray(group.items) && group.items.length) {
          group.items.forEach((child) => {
            subgroup.append(preparedButton(child.label, 'mobile-menu__link', child.suggestedUrl));
          });
        }

        body.append(subgroup);
      });

      details.append(body);
      container.append(details);
    });
  };

  document.querySelectorAll('[data-prepared-nav]').forEach((container) => {
    if (!preparedNavigation.length) return;
    if (container.dataset.preparedNav === 'mobile') {
      renderMobileNavigation(container);
    } else {
      renderDesktopNavigation(container);
    }
  });

  document.addEventListener('pointermove', closePreparedDropdownsOutsidePointer, { passive: true });
  document.addEventListener('mousemove', closePreparedDropdownsOutsidePointer, { passive: true });


};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
(() => {
  const navigationNode = document.getElementById('GearonimoPreparedNavigation');
  if (!navigationNode) return;

  let navigation = [];
  try {
    navigation = JSON.parse(navigationNode.textContent || '[]');
  } catch {
    return;
  }

  const closeDesktopItem = (navItem) => {
    if (!navItem) return;
    window.clearTimeout(navItem._preparedCloseTimer);
    navItem.classList.remove('is-open');
    navItem.querySelector('.primary-nav__link')?.setAttribute('aria-expanded', 'false');
  };

  const closeDesktopItems = (currentItem) => {
    document.querySelectorAll('.primary-nav__item.is-open').forEach((navItem) => {
      if (navItem === currentItem) return;
      closeDesktopItem(navItem);
    });
  };

  const openDesktopItem = (navItem) => {
    if (!navItem) return;
    window.clearTimeout(navItem._preparedCloseTimer);
    closeDesktopItems(navItem);
    navItem.classList.add('is-open');
    navItem.querySelector('.primary-nav__link')?.setAttribute('aria-expanded', 'true');
  };

  const makeAnchorFromControl = (control, item) => {
    if (!control || control.tagName === 'A' || !item?.suggestedUrl) return control;
    const link = document.createElement('a');
    Array.from(control.attributes).forEach((attribute) => {
      if (attribute.name === 'type') return;
      link.setAttribute(attribute.name, attribute.value);
    });
    link.href = item.suggestedUrl;
    link.textContent = control.textContent || item.label;
    control.replaceWith(link);
    return link;
  };

  const patchDesktopNavigation = () => {
    const desktopNav = document.querySelector('[data-prepared-nav="desktop"]');
    if (!desktopNav) return;

    Array.from(desktopNav.children).forEach((navItem, index) => {
      const item = navigation[index];
      const hasDropdown = Array.isArray(item?.groups) && item.groups.length > 0;
      if (!hasDropdown || !item.suggestedUrl) return;

      const directChild = Array.from(navItem.children).find((child) => (
        child.classList && child.classList.contains('primary-nav__link')
      ));
      const topLink = makeAnchorFromControl(directChild, item);
      if (!topLink) return;

      topLink.href = item.suggestedUrl;
      topLink.classList.add('primary-nav__link--toggle');
      topLink.setAttribute('aria-haspopup', 'true');
      if (!topLink.hasAttribute('aria-expanded')) topLink.setAttribute('aria-expanded', 'false');

      if (!navItem.dataset.categoryLinkPatched) {
        topLink.addEventListener('focus', () => openDesktopItem(navItem));
        topLink.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          closeDesktopItem(navItem);
          topLink.blur();
        });

        navItem.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (navItem.matches(':focus-within') || navItem.matches(':hover')) return;
            closeDesktopItem(navItem);
          }, 0);
        });
        navItem.dataset.categoryLinkPatched = 'true';
      }
    });
  };

  const patchMobileNavigation = () => {
    const mobileNav = document.querySelector('[data-prepared-nav="mobile"]');
    if (!mobileNav) return;

    Array.from(mobileNav.children).forEach((navItem, index) => {
      const item = navigation[index];
      const hasDropdown = Array.isArray(item?.groups) && item.groups.length > 0;
      if (!hasDropdown || !item.suggestedUrl || navItem.tagName !== 'DETAILS') return;

      const body = navItem.querySelector('.mobile-menu__group-body');
      if (!body || body.querySelector('[data-mobile-all-category]')) return;

      const allLabel = `All ${item.label}`;
      const existingAllLink = Array.from(body.children).find((child) => (
        child.textContent?.trim() === allLabel && child.getAttribute('href') === item.suggestedUrl
      ));
      if (existingAllLink) {
        existingAllLink.dataset.mobileAllCategory = 'true';
        return;
      }

      const link = document.createElement('a');
      link.href = item.suggestedUrl;
      link.className = 'mobile-menu__heading';
      link.dataset.mobileAllCategory = 'true';
      link.textContent = allLabel;
      body.prepend(link);
    });
  };

  const patchNavigation = () => {
    patchDesktopNavigation();
    patchMobileNavigation();
    const panel = document.querySelector('[data-prepared-nav="mobile"]');
    if (panel && !panel.querySelector('[data-mobile-category-close]')) {
      const close = document.createElement('button');
      close.type = 'button';
      close.dataset.mobileCategoryClose = '';
      close.setAttribute('aria-label', 'Close category menu');
      close.textContent = '×';
      panel.append(close);
      close.addEventListener('click', () => {
        const menu = panel.closest('details');
        panel.querySelectorAll('details[open]').forEach(group => { group.open = false; });
        if (menu) { menu.open = false; menu.querySelector('summary')?.focus({preventScroll:true}); }
      });
      const style = document.createElement('style');
      style.textContent = '[data-mobile-category-close]{display:none}@media(max-width:990px){[data-prepared-nav="mobile"]{padding-top:52px!important}[data-mobile-category-close]{display:flex;align-items:center;justify-content:center;position:absolute;top:8px;right:10px;width:36px;height:36px;padding:0;border:1px solid #d9d0c4;border-radius:50%;background:#f7f4ee;color:#242321;font-size:26px;line-height:1;cursor:pointer;z-index:5}[data-mobile-category-close]:focus-visible{outline:2px solid #ea4600;outline-offset:3px}}';
      document.head.append(style);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchNavigation, { once: true });
  } else {
    patchNavigation();
  }

  // The shared renderer and patch run together at DOMContentLoaded.
})();

(() => {
const init = () => {
let nav;try{nav=JSON.parse(document.getElementById('GearonimoPreparedNavigation').textContent);}catch(error){return;}
const pathOf = url => new URL(url,location.origin).pathname.replace(/\/$/,'');
const keyOf = url => {const u=new URL(url,location.origin);return pathOf(url)+(u.hash.includes('camp_category=')?'#'+new URLSearchParams(u.hash.slice(1)).get('camp_category'):'');};
const entries=nav.flatMap(d=>[d,...(d.groups||[]).flatMap(g=>g.items||[])]);
const anchor=(item,cls='')=>{const a=document.createElement('a');a.href=item.suggestedUrl;a.textContent=item.label;a.className=cls;return a;};
const shortLabels={'Women’s Clothing & Footwear':'Women','Men’s Clothing & Footwear':'Men','Kids’ Clothing & Footwear':'Kids','Unisex Clothing & Footwear':'Unisex','All Ski Gear':'Ski Gear','All Snowboard Gear':'Snowboard Gear','Backcountry Touring':'Ski Touring','All Snow Accessories':'Snow Accessories','Protection & Hardware':'Hardware','Nuts & Passive Protection':'Passive Protection','All Ice & Mountaineering Gear':'Ice & Mountaineering','Climbing Guidebooks':'Guidebooks','Backpacks & Daypacks':'Backpacks','Hiking Shoes & Boots':'Hiking Footwear','Camp Kitchen & Water':'Kitchen & Water','Shelter & Sleep Accessories':'Shelter & Sleep','Trail Accessories & Guides':'Trail Accessories','Hiking Guides & Maps':'Hiking Guides','Vehicle Racks & Travel Bags':'Racks & Travel','Water & Fishing Gear':'Water & Fishing','Casual Shoes & Sandals':'Shoes & Sandals'};
const shortLabel=label=>shortLabels[label]||label;
const current=pathOf(location.href);
const direct=entries.find(i=>pathOf(i.suggestedUrl)===current);
const nativeRoot=document.querySelector('[id^="NewCollection-"]');
const root=nativeRoot||document.querySelector('[id^="MoreGearBroad-"]');
if(root){
const picker=root.querySelector('.nc-category-menu');
if(picker){
let dept=nav.find(d=>pathOf(d.suggestedUrl)===current)||nav.find(d=>(d.groups||[]).some(g=>(g.items||[]).some(i=>pathOf(i.suggestedUrl)===current)));
if(!dept){const crumbs=[...root.querySelectorAll('.nc-breadcrumb a')].map(a=>pathOf(a.href));dept=nav.find(d=>crumbs.includes(pathOf(d.suggestedUrl)));}
const types=[...picker.querySelectorAll('.nc-category-label')].filter(p=>/ types$/.test(p.textContent.trim())).flatMap(p=>[p.cloneNode(true),p.nextElementSibling?.cloneNode(true)]).filter(Boolean);
if(dept||current==='/collections/all'){
const breadcrumb=root.querySelector('.nc-breadcrumb');if(breadcrumb&&direct&&nativeRoot){breadcrumb.replaceChildren(anchor({label:'Home',suggestedUrl:'/'}));if(dept&&pathOf(dept.suggestedUrl)!==current){const slash=document.createElement('span');slash.textContent='/';slash.setAttribute('aria-hidden','true');breadcrumb.append(slash,anchor(dept));}const slash=document.createElement('span');slash.textContent='/';slash.setAttribute('aria-hidden','true');const selected=document.createElement('span');selected.textContent=direct.label;selected.setAttribute('aria-current','page');breadcrumb.append(slash,selected);}

picker.replaceChildren();picker.classList.add('mapping-category-menu');
const all=anchor({label:dept&&pathOf(dept.suggestedUrl)===current?'View all':dept&&dept.label!=='Shop All'?'All '+(dept.label==='Clothing & Footwear'?'Clothing':dept.label):'Shop All',suggestedUrl:dept?dept.suggestedUrl:'/collections/all?sort_by=created-descending'});if(pathOf(all.href)===current)all.setAttribute('aria-current','page');picker.append(all);
const groups=dept&&dept.groups.length?dept.groups:[{label:'Shop by department',items:nav.slice(1)}];
const skiTypePaths=['all-mountain-skis','powder-skis','freestyle-and-park-skis','racing-skis','touring-skis','telemark-skis-gear','classic-cross-country-skis','skate-skis','ski-blades'].map(handle=>'/collections/'+handle);
const familyGroup=skiTypePaths.includes(current)?groups.find(g=>g.items.some(i=>pathOf(i.suggestedUrl)==='/collections/backcountry-skiing-skis')):null;
const selectedGroup=familyGroup||groups.find(g=>g.items.some(i=>pathOf(i.suggestedUrl)===current));
const visibleGroups=selectedGroup&&dept&&pathOf(dept.suggestedUrl)!==current?[selectedGroup]:groups;
const seen=new Set([keyOf(all.href)]);
visibleGroups.flatMap(g=>g.items).forEach(i=>{if(seen.has(keyOf(i.suggestedUrl)))return;seen.add(keyOf(i.suggestedUrl));const a=anchor({...i,label:shortLabel(i.label)});if(pathOf(i.suggestedUrl)===current)a.setAttribute('aria-current','page');picker.append(a);});picker.append(...types);
}
}
if(direct){const h=root.querySelector('.nc-heading h1');if(h)h.textContent=direct.label;const last=root.querySelector('.nc-breadcrumb [aria-current="page"]');if(last)last.textContent=direct.label;}
}

// Compact collection rails retain every destination and native touch scrolling.
document.querySelectorAll('.nc-category-rail').forEach((rail,index)=>{
 const menu=rail.querySelector('.nc-category-menu');if(!menu)return;
 menu.querySelectorAll('a').forEach(a=>{const label=a.textContent.trim();if(shortLabels[label])a.textContent=shortLabel(label);if(a.matches('[data-camp-category="all"]'))a.textContent='View all';});
 const title=rail.querySelector('.nc-rail-title');if(!title)return;
 menu.id=menu.id||'collection-category-rail-'+index;
 const tools=document.createElement('span');tools.className='mapping-rail-tools';
 const hint=document.createElement('span');hint.className='mapping-rail-hint';hint.textContent='Swipe to browse';tools.append(hint);
 const buttons=[[-1,'Previous categories','‹'],[1,'More categories','›']].map(([direction,label,symbol])=>{const button=document.createElement('button');button.type='button';button.className='mapping-rail-arrow';button.setAttribute('aria-label',label);button.setAttribute('aria-controls',menu.id);button.textContent=symbol;button.addEventListener('click',()=>menu.scrollBy({left:direction*Math.max(200,menu.clientWidth*.7),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));tools.append(button);return button;});title.append(tools);
 const update=()=>{const max=menu.scrollWidth-menu.clientWidth;tools.hidden=max<3;buttons[0].disabled=menu.scrollLeft<2;buttons[1].disabled=menu.scrollLeft>max-2;};
 menu.addEventListener('scroll',update,{passive:true});if(window.ResizeObserver)new ResizeObserver(update).observe(menu);window.addEventListener('load',update,{once:true});update();
});
// Keep department labels consistent wherever an existing card or footer links to them.
nav.forEach(d=>{document.querySelectorAll('a[href]').forEach(a=>{if(pathOf(a.href)!==pathOf(d.suggestedUrl)||a.closest('.primary-nav,.mobile-menu,.nc-category-menu'))return;const strong=a.querySelector('strong');if(strong&&a.matches('.gearonimo-footer-category-card'))strong.textContent=d.label;else if(a.closest('.footer-minimal__nav')&&a.children.length===0)a.textContent=d.label;});});

// Keep draft review links/forms in this draft, including links rendered after load.
const preview=new URLSearchParams(location.search).get('preview_theme_id')||(()=>{try{const data=JSON.parse(document.getElementById('OnlineStorePreviewBarNextData')?.textContent||'{}');return data.theme?.isDraft?String(data.theme.id):'';}catch(error){return '';}})();
if(preview){
 const preserve=a=>{if(!a)return;try{const u=new URL(a.href,location.origin);if(u.origin===location.origin&&/^\/(collections|products|pages|search)(\/|$)/.test(u.pathname)){u.searchParams.set('preview_theme_id',preview);a.href=u.href;}}catch(error){}};
 document.querySelectorAll('a[href]').forEach(preserve);
 document.addEventListener('click',event=>preserve(event.target.closest('a[href]')),true);
 document.querySelectorAll('form').forEach(form=>{if(form.method.toLowerCase()!=='get')return;const u=new URL(form.action,location.origin);if(u.origin!==location.origin)return;let input=form.querySelector('input[name="preview_theme_id"]');if(!input){input=document.createElement('input');input.type='hidden';input.name='preview_theme_id';form.append(input);}input.value=preview;});
}
const style=document.createElement('style');style.textContent=
'.primary-nav__dropdown .mapping-all-link{grid-column:1/-1;font-weight:800;border-bottom:1px solid #ddd;padding-bottom:12px;margin-bottom:4px}.primary-nav__dropdown-heading[data-inert-link],.mobile-menu__heading[data-inert-link]{cursor:default!important;pointer-events:none;color:#a93c0c!important;text-transform:uppercase;font-size:12px;letter-spacing:.06em}.site-header .primary-nav__dropdown{background:#fff!important;backdrop-filter:none!important;color:#202020!important;box-shadow:0 12px 24px #0002}.primary-nav__dropdown{max-height:calc(100dvh - 150px);overflow-y:auto}@media(min-width:991px){.primary-nav__item:not(.is-open)>.primary-nav__dropdown{display:none!important}.primary-nav__item.is-open>.primary-nav__dropdown{display:grid!important;opacity:1!important;visibility:visible!important}.primary-nav__dropdown{grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:18px!important}.primary-nav__dropdown-heading{white-space:normal!important}}.new-collection .nc-category-rail .mapping-category-menu{display:block!important;overflow:visible!important;height:auto!important;max-height:none!important;white-space:normal!important}.new-collection .mapping-category-groups .nc-category-links{display:flex!important;flex-direction:column!important}.mapping-category-groups:has(>section:only-child) .nc-category-links{display:grid!important;grid-template-columns:repeat(auto-fit,minmax(180px,1fr))!important}.new-collection .mapping-category-groups:has(>section:only-child){grid-template-columns:1fr!important}.new-collection .nc-category-rail .mapping-category-groups .nc-category-links a{white-space:normal!important;max-width:none!important;min-width:0!important;width:auto!important;overflow:visible!important;display:flex!important;line-height:1.35!important}.primary-nav__dropdown>.primary-nav__group:only-of-type{grid-column:1/-1}.primary-nav__dropdown>.primary-nav__group:only-of-type .primary-nav__dropdown-list{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px 20px}.mapping-category-all{display:inline-block;font-weight:800;margin-bottom:14px;text-decoration:underline;text-underline-offset:4px}.mapping-category-groups{display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:20px}.mapping-category-groups h2{font-size:13px!important;color:#a93c0c;margin:0 0 8px;text-transform:uppercase;letter-spacing:.04em}.mapping-category-groups .nc-category-links{display:flex;flex-direction:column;gap:3px;align-items:stretch}.mapping-category-groups .nc-category-links a{padding:8px 10px;min-height:38px;border:1px solid transparent;border-radius:5px;background:transparent}.mapping-category-groups a:hover,.mapping-category-groups a:focus-visible{background:#f4eee7;border-color:#ddc9b9}.mapping-category-groups a[aria-current]{font-weight:800;background:#f9eee5;border-color:#c24b14;color:#a43b0a}@media(max-width:990px){.new-collection .mapping-category-groups:has(>section:only-child) .nc-category-links{grid-template-columns:repeat(2,minmax(0,1fr))!important}.mobile-menu__panel{background:#fff!important}.mobile-menu__group-body{padding-bottom:12px}.mobile-menu__subgroup{gap:0!important;padding:10px 0!important;margin:8px 0!important}.mobile-menu__heading[data-inert-link]{margin:0 0 6px!important;padding:0!important;min-height:0!important}.mobile-menu__subgroup{margin:14px 0}.mobile-menu__link{min-height:42px}.mapping-category-groups{grid-template-columns:repeat(2,minmax(0,1fr));gap:16px 10px}.mapping-category-groups .nc-category-links a{font-size:13px;min-height:44px;padding:9px 6px}.mapping-category-menu{max-height:none!important}.primary-nav__link{white-space:normal}}.new-collection .nc-category-rail .mapping-category-menu{display:flex!important;flex-wrap:nowrap!important;overflow-x:auto!important;overflow-y:hidden!important;align-items:center!important;white-space:nowrap!important;gap:8px!important;padding:3px 2px 12px!important}.new-collection .nc-category-rail .nc-category-menu a{font-weight:650!important;font-size:14px!important;min-height:44px!important;padding:11px 16px!important}.new-collection .nc-category-rail .nc-rail-title{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:8px;min-height:28px}.mapping-rail-tools{display:flex;gap:6px;align-items:center}.mapping-rail-tools[hidden]{display:none!important}.mapping-rail-arrow{display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;padding:0;border:1px solid #ddd;border-radius:50%;background:#fff;color:#333;font-size:23px;line-height:1;cursor:pointer}.mapping-rail-arrow:disabled{opacity:.3;cursor:default}.mapping-rail-arrow:focus-visible{outline:2px solid #ea4600;outline-offset:2px}.mapping-rail-hint{display:none}@media(max-width:760px){.new-collection .nc-category-rail .nc-category-menu a{font-size:13px!important;padding:10px 14px!important}.mapping-rail-arrow{display:none}.mapping-rail-hint{display:inline;font-size:10px;font-weight:500;letter-spacing:0;text-transform:none;color:#777}}@media(min-width:991px){.mapping-hover-bridge{display:none;pointer-events:auto;background:transparent}.primary-nav__item.is-open>.mapping-hover-bridge{display:block}}';document.head.append(style);
};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
